import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { apiService } from '../services/api';
import Loader from './Loader';
import { useNotifications } from './NotificationSystem';
import { handleApiError } from '../utils/errorHandler';
import './Auth.css';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const { showSuccess, showError } = useNotifications();

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setError('Verification token is missing. Please check your email for the correct verification link.');
        setLoading(false);
        return;
      }

      try {
        const response = await apiService.verifyEmail(token);
        const successMessage = response.message || 'Email verified successfully.';
        setMessage(successMessage);
        setError('');
        showSuccess('Email Verified', successMessage);
      } catch (err: any) {
        const appError = handleApiError(err);
        setError(appError.message);
        showError('Verification Failed', appError.message);
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [searchParams, showSuccess, showError]);

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo">
            <span className="logo-icon">💰</span>
            <h1>RokdaHisab</h1>
          </div>
          <h2>Email Verification</h2>
        </div>

        <div className="auth-form">
          {loading && (
            <Loader message="Verifying your email..." size="large" />
          )}

          {error && !loading && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          {message && !loading && (
            <div className="success-message" style={{ marginBottom: '20px' }}>
              <span className="success-icon">✅</span>
              {message}
            </div>
          )}

          {!loading && (
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <Link to="/login" className="auth-button" style={{ display: 'inline-block', textDecoration: 'none' }}>
                Go to Login
              </Link>
            </div>
          )}

          <div className="auth-footer" style={{ marginTop: '30px' }}>
            <p>
              Need help?{' '}
              <Link to="/login" className="auth-link">
                Contact Support
              </Link>
            </p>
          </div>
        </div>
      </div>

      <div className="auth-background">
        <div className="floating-shapes">
          <div className="shape shape-1">💳</div>
          <div className="shape shape-2">📊</div>
          <div className="shape shape-3">💰</div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;

